module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAMAAAAi2JHqAAAAP1BMVEUAAAD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgBOpWD0AAAAFHRSTlMAb4X1oJqOaWRgluyLkNyCdl0+CdiAF+8AAAB3SURBVCjPrdPbCoAgEARQTdPyUlb+/7cW5Mu6C4PgPp6B8jaKjz+ifTgv9RsrczUy1yhz3SmnxkVmTdnN4CxzaOyHeKO8jjM/Eyvz2fhSdMx/D7cCDr7D/gvXyfeFg4AC3wcZBboP3LwgoaAo9M55L3CPeO94T19jFxYaFsNOuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/prev.png
// module id = 903
// module chunks = 5